import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { onboardingTasks } from '@ourbranch/onboarding-tasks';

import reviewImagesIcon from 'core/assets/svg/ic-review-images.svg';
import { Card } from 'core/components/card';
import { useStore } from 'core/store';
import ReviewInventoryImagesModal from '../review-inventory-images-modal/review-inventory-images-modal';

import useStyles from './inventory-images.styles';

const getImagesTitle = ({ hasInventory, hasSpp }) => {
  if (hasInventory && hasSpp) {
    return 'Self-guided inspection and SPP Images';
  }
  if (hasSpp) {
    return 'SPP Images';
  }
  return 'Self-guided inspection Images';
};

const InventoryImages = observer(() => {
  const classes = useStyles();
  const [showReviewInventoryImagesModal, setShowReviewInventoryImagesModal] = useState(false);
  const { account } = useStore();
  const { startedUploadingInventoryImages, tasks = [] } = account;

  if (!startedUploadingInventoryImages) {
    return null;
  }

  const hasInventoryTask = tasks.some((t) => t.taskName === onboardingTasks.CompleteInventory);
  const hasSppTask = tasks.some((t) => t.taskName === onboardingTasks.NeedScheduledPersonalPropertyImages);
  const title = getImagesTitle({ hasInventory: hasInventoryTask, hasSpp: hasSppTask });

  return (
    <>
      <Card className={classes.card}>
        <div className={classes.titleContainer}>
          <span className={classes.title}>{title}</span>
          <span className={classes.subtitle}>
            This member has either started submitting images or completed their self-guided inspection.
          </span>
        </div>
        <div className={classes.buttons}>
          <Button
            disableFocusRipple
            className={classes.reviewImagesButton}
            onClick={() => setShowReviewInventoryImagesModal(true)}
            variant="text"
            color="secondary"
          >
            <img alt="review images icon" className={classes.reviewImagesIcon} src={reviewImagesIcon} />
            Review
          </Button>
        </div>
      </Card>
      <ReviewInventoryImagesModal
        open={showReviewInventoryImagesModal}
        onClose={() => setShowReviewInventoryImagesModal(false)}
      />
    </>
  );
});

export default InventoryImages;
